import { TagButtonList } from "./TagButtonList";

export const DesktopTags = () => {
  return <TagButtonList />;
};
